import { render } from "./FeatureFlag.vue?vue&type=template&id=6ca65546"
import script from "./FeatureFlag.vue?vue&type=script&lang=js"
export * from "./FeatureFlag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__